module.exports = "/images/Make marketing easier and faster.svg?365c1a63891f21e5b872b056142f55cd";